"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Invitations = void 0;
var react_1 = __importStar(require("react"));
var react_admin_1 = require("react-admin");
var RAStyles_1 = require("../common/ReactAdmin/RAStyles");
var react_i18next_1 = require("react-i18next");
var Pagination_1 = __importDefault(require("../common/ReactAdmin/Pagination"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var Teams_module_css_1 = __importDefault(require("../Teams/Teams.module.css"));
var ApiManager_1 = __importDefault(require("@/functions/ApiManager"));
var RAStyles_2 = require("@/Components/common/ReactAdmin/RAStyles");
var styles_1 = require("@mui/material/styles");
var ListActions = function () { return (react_1.default.createElement(react_admin_1.TopToolbar, { className: "my-auto" },
    react_1.default.createElement(styles_1.ThemeProvider, { theme: RAStyles_2.ExportButtonTheme },
        react_1.default.createElement(react_admin_1.ExportButton, { sx: {
                position: "relative",
                bottom: "65px",
                marginRight: "160px",
                color: "var(--info-color)",
                backgroundColor: "var(--secondary-color)",
                fontFamily: "Geomanist-bold",
                borderRadius: "4px",
                textTransform: "capitalize",
                padding: "15px",
                fontSize: "14px",
                height: "37px",
                boxShadow: " 6px 0px 18px #2d2d2d0c ",
                "&:hover": {
                    backgroundColor: "var(--secondary-color)",
                    color: "var(--info-color)",
                },
                "&:active": {
                    backgroundColor: "var(--info-color)",
                    color: "var(--secondary-color)",
                    "& .MuiSvgIcon-root": {
                        color: "var(--secondary-color)",
                    }
                }
            } })))); };
var CheckBoxAction = function (_a) {
    var onCheckBoxTick = _a.onCheckBoxTick;
    var selectedIds = (0, react_admin_1.useListContext)().selectedIds;
    react_1.default.useEffect(function () {
        onCheckBoxTick(selectedIds);
    }, [selectedIds]);
    return react_1.default.createElement(react_1.default.Fragment, null);
};
var Invitations = function (props) {
    var invitationsFilters = [react_1.default.createElement(react_admin_1.SearchInput, { source: "email", alwaysOn: true, key: "queryFilter" })];
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var refresh = (0, react_admin_1.useRefresh)();
    var _a = (0, react_1.useState)(false), checkBoxIsActive = _a[0], setCheckBoxIsActive = _a[1];
    var _b = (0, react_1.useState)([]), bulkActionInvitationIds = _b[0], setBulkActionInvitationIds = _b[1];
    var onCheckBoxTickHandler = function (selectedIds) {
        if (selectedIds.length > 0) {
            setCheckBoxIsActive(true);
            setBulkActionInvitationIds(selectedIds);
        }
        else {
            setCheckBoxIsActive(false);
            setBulkActionInvitationIds([]);
        }
    };
    var onDeleteHandler = function () {
        bulkActionInvitationIds.forEach(function (invitationId) {
            ApiManager_1.default.deleteInvitation(invitationId).then(function () {
                refresh();
            });
        });
    };
    return (react_1.default.createElement(styles_1.ThemeProvider, { theme: RAStyles_1.RaTeamsFilterInputTheme },
        react_1.default.createElement(react_admin_1.ListBase, __assign({}, props),
            react_1.default.createElement("div", { style: { display: "flex", gap: "10px", marginBottom: "15px" } },
                react_1.default.createElement(q_play_components_1.Button, { text: t("Delete"), variant: "empty", size: "small", style: { background: "var(--bs-body-bg)" }, className: Teams_module_css_1.default.list_view_quick_actions, isDisabled: !checkBoxIsActive, onClick: onDeleteHandler }),
                react_1.default.createElement(styles_1.ThemeProvider, { theme: RAStyles_2.RaSearchInputTheme },
                    react_1.default.createElement(react_admin_1.ListToolbar, { filters: invitationsFilters, actions: react_1.default.createElement(ListActions, null) }))),
            react_1.default.createElement(styles_1.ThemeProvider, { theme: RAStyles_1.RaDatagridTeamsTheme },
                react_1.default.createElement(react_admin_1.Datagrid, { hover: false, sx: RAStyles_1.RaInvitationsDataGridSx, bulkActionButtons: react_1.default.createElement(CheckBoxAction, { onCheckBoxTick: onCheckBoxTickHandler }) },
                    react_1.default.createElement(react_admin_1.TextField, { source: "email", label: t("Email"), sx: __assign(__assign({}, RAStyles_1.RaTextFieldSx), { fontFamily: "Geomanist-Bold" }) }),
                    react_1.default.createElement(react_admin_1.ReferenceArrayField, { label: t("Teams"), reference: "qteams", source: "qteams", sort: { field: "name", order: "ASC" }, textAlign: "center" },
                        react_1.default.createElement(react_admin_1.SingleFieldList, { linkType: false, sx: { display: "flex", justifyContent: "center" } },
                            react_1.default.createElement(react_admin_1.ChipField, { source: "name" }))),
                    react_1.default.createElement(react_admin_1.DateField, { showTime: false, label: t("Invited date"), source: "created_at", textAlign: "center" }))),
            react_1.default.createElement(Pagination_1.default, null))));
};
exports.Invitations = Invitations;
exports.default = exports.Invitations;
